// @ts-strict-ignore
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component, ElementRef,
  forwardRef,
  Inject, NgZone, OnInit, ViewChild, AfterViewChecked
} from '@angular/core';
import {
  SohoMessageService,
  SohoModalDialogService, SohoSearchFieldComponent,
  SohoToastService
} from 'ids-enterprise-ng';
import { LMApplicationMenuService, LMApplicationMenuSubMenuService } from '@app/components';
import { LMErrorUtilService } from '@services/utils/lm-error-util.service';
import { LMLoggerService } from '@services/lm-logger.service';
import { LMUrlUtilService } from '@services/utils/lm-url-util.service';
import { LMLoginService } from '@login/lm-login.service';
import { LMActionFormDialogService } from '@modal/lm-action-form-dialog.service';
import { LMSpecService } from '@services/lm-spec.service';
import { LMContextService } from '@services/lm-context.service';
import { LMContextUtilService } from '@utils/lm-context-util.service';
import { LMGlobalUtilService } from '@utils/lm-global-util.service';
import { LMGlobalPersonalizationService, LMGlobalStateService } from '@app/states';
import { LMApplicationMenuAsOfDateDialogService } from '@components/applicationmenu/asofdate/lm-application-menu-asofdate-dialog.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMApplicationMenuSearchService } from '@components/applicationmenu/search/lm-application-menu-search.service';
import { LMBusyIndicatorService } from '@services/lm-busyindicator.service';
import { LMApplicationMenuUserContextDialogService } from '@app/components';
import { LMFormRequestService } from '@form/services/lm-form-request.service';
import { Router } from '@angular/router';
import { LMApplicationMenuBaseDirective } from '@components/applicationmenu/lm-application-menu-base.directive';
import { LMBrowserUtilService, LMUniqueIdService } from '@app/utils';
import { LMThemeService } from '@banner/lm-theme.service';
import { state, style, trigger } from '@angular/animations';
import { LMRoamingUIProfileService, RoamingUIProfileResult, RoamingUIProfileResponse } from '@services/lm-roamingUIProfile.service';
import { LMCreateReportDialogService, LMReportsCatalogService, LMReportPersonalizationDialogService } from '@report/index';
import * as urltemplate from 'url-template';
import { LMComponentInfoService, LMRouteComponentService } from '@app/services';
import { LMWebAppService } from '@services/lm-webapp.service';
import { LMKeyboardShortcutsDialogService } from "@modal/lm-keyboard-shortcuts-dialog.service";

@Component({
  selector: 'lm-application-menu-v2',
  templateUrl: 'lm-application-menu-v2.component.html',
  styleUrls: [ 'lm-application-menu-v2.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ LMRoamingUIProfileService ],
  animations: [
  trigger('paneDisplay', [
    state('block', style({
      display: 'block',
      })),
    state('none', style({
      display: 'none',
      }))
    ]),
  ],
  })
export class LMApplicationMenuV2Component extends LMApplicationMenuBaseDirective implements OnInit, AfterViewChecked {
  public displayMenuGuide = this.showMenuGuide();

  @ViewChild('SearchField') searchField: SohoSearchFieldComponent;

  constructor(
    protected sohoModalDialogService: SohoModalDialogService,
    protected sohoToastService: SohoToastService,
    protected lmAsOfDateService: LMApplicationMenuAsOfDateDialogService,
    protected lmContextService: LMContextService,
    protected lmApplicationMenuService: LMApplicationMenuService,
    protected lmFormRequestService: LMFormRequestService,
    protected lmFormatUtilService: LMFormatUtilService,
    protected lmSpecService: LMSpecService,
    protected lmWebAppService: LMWebAppService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected lmLoggerService: LMLoggerService,
    protected lmUrlUtilService: LMUrlUtilService,
    protected lmGlobalUtilService: LMGlobalUtilService,
    protected lmLoginService: LMLoginService,
    protected lmContextUtilService: LMContextUtilService,
    protected lmReportPersonalizationDialogService: LMReportPersonalizationDialogService,
    protected lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    protected lmGlobalStateService: LMGlobalStateService,
    protected lmUniqueIdService: LMUniqueIdService,
    protected sohoMessageService: SohoMessageService,
    protected lmApplicationMenuSearchService: LMApplicationMenuSearchService,
    protected lmBusyIndicatorService: LMBusyIndicatorService,
    protected lmUserContextService: LMApplicationMenuUserContextDialogService,
    protected lmRoamingUIProfileService: LMRoamingUIProfileService,
    protected lmBrowserUtilService: LMBrowserUtilService,
    @Inject(forwardRef(() => LMActionFormDialogService)) protected lmActionFormDialogService, // LMActionFormDialogService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected router: Router,
    protected lmThemeService: LMThemeService,
    protected lmCreateReportDialogService: LMCreateReportDialogService,
    protected lmCommonReportsService: LMReportsCatalogService,
    protected lmComponentInfoService: LMComponentInfoService,
    protected ngZone: NgZone,
    protected lmApplicationMenuSubMenuService: LMApplicationMenuSubMenuService,
    protected routeComponent: LMRouteComponentService,
    protected lmKeyboardShortcutsDialogService: LMKeyboardShortcutsDialogService
  ) {
    super(
      sohoModalDialogService,
      sohoToastService,
      lmAsOfDateService,
      lmContextService,
      lmApplicationMenuService,
      lmFormRequestService,
      lmFormatUtilService,
      lmSpecService,
      lmWebAppService,
      lmErrorUtilService,
      lmLoggerService,
      lmUrlUtilService,
      lmGlobalUtilService,
      lmLoginService,
      lmContextUtilService,
      lmReportPersonalizationDialogService,
      lmGlobalPersonalizationService,
      lmGlobalStateService,
      lmUniqueIdService,
      sohoMessageService,
      lmApplicationMenuSearchService,
      lmBusyIndicatorService,
      lmUserContextService,
      lmActionFormDialogService,
      changeDetectorRef,
      router,
      lmRoamingUIProfileService,
      lmThemeService,
      lmCreateReportDialogService,
      lmBrowserUtilService,
      lmCommonReportsService,
      lmComponentInfoService,
      ngZone,
      lmApplicationMenuSubMenuService,
      routeComponent,
      lmKeyboardShortcutsDialogService
    );
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngAfterViewChecked() {
    super.ngAfterViewChecked();

    // Kludge to disable autocomplete on application menu
    // Autocomplete callbacks are auto firing after IDS ModuleNav implemenation
    // https://jira.infor.com/browse/LMWEB-18716
    if (this.searchField) {
      const searchField = this.searchField['jQueryElement'];
      if (
        $(searchField)?.data('searchfield')?.autocompleteAPI?.settings?.displayResultsCallback &&
        $(searchField)?.data('searchfield')?.autocompleteAPI?.settings?.displayResultsCallback?.name !== 'noop'
      ) {
        const kludge = function noop() { return false; };
        $(searchField).data('searchfield').autocompleteAPI.settings.displayResultsCallback = kludge;
      }
    }
  }

  public updateButtons() {
    this.updateMenuButtons();
  }

  public onSelectRole($event): void {
    this.selectRole($event);
    this.toggleRoleSwitcherPanel();
  }

  public onToggleActionMenu(e?: Event) {
    this.actionMenu.nativeElement.style.display = this.actionMenuIsOpen ? 'none' : 'block';
    this.actionMenuIsOpen = !this.actionMenuIsOpen;
  }

  public openNotificationsLink(link: string) {
    this.displayRedDot = false;
    // Convert timestamp from simplified ISO format (YYYY-MM-DDTHH:mm:ss.sssZ) to Landmark format (yyyyMMddHHmmssSS)
    const curTimeStamp = new Date().toISOString().slice(-24).replace(/\D/g, '').slice(0, 16);
    this.lmRoamingUIProfileService.setLastViewedNotification(curTimeStamp)
      .subscribe(
        (results: RoamingUIProfileResponse) => {
          if (results.status === RoamingUIProfileResult.COMPLETED) {
            this.lmLoggerService.log('RoamingUIProfile Updated');
          }
        });
    this.openLink(link);
  }

  public openLink(link: string) {
    const compiledTemplate = urltemplate.parse(link);
    link = compiledTemplate.expand({
      urlPdlOrDa: this.lmContextService.getUrlPdlOrDa(),
      webApp:     this.lmContextService.getCurrentWebAppSpec().webAppName
    });
    this.lmContextService.setClearNextPageState(true);
    this.lmGlobalUtilService.navigateByUrl(link);
  }

  private showMenuGuide(): boolean {
    if (this.lmBrowserUtilService.isMobile || this.lmContextService.isAnonymousUser()) {
      return false;
    }

    const context = this.lmContextService.getContext();
    const webProfile = context.roamingUIProfile ? context.roamingUIProfile : {};

    if (context.showMenuGuide) {
      if (webProfile) {
        if (webProfile.menuV2GuideViewed === undefined || !webProfile.menuV2GuideViewed) {
          return true;
        } else {
          return false;
        }
      }
    } else {
      return false;
    }
  }

  public toggleRoleSwitcherPanel(): void {
    this.rolesPaneIsOpen = !this.rolesPaneIsOpen;
  }

  public onAppMenuSwitcherClicked(e: Event) {
    this.toggleRoleSwitcherPanel();

    // Prevent app menu from closing
    e?.stopImmediatePropagation();
  }

  public dismissSettingsGuide() {
    this.settingsGuide.nativeElement.style.display = 'none';
    this.appSwitcherGuide.nativeElement.style.display = 'flex';
  }

  public useRoleSwitcher() {
    return true;
  }

  public dismissAppSwitcherGuide() {
    this.appSwitcherGuide.nativeElement.style.display = 'none';
    this.lmRoamingUIProfileService.setMenuV2Viewed()
      .subscribe(
        (results: RoamingUIProfileResponse) => {
          if (results.status === RoamingUIProfileResult.COMPLETED) {
            this.lmLoggerService.log('RoamingUIProfile Updated');
          }
        });
  }

  public updateMenuButtons() {
    const notificationsButton = {
      icon: 'notification',
      label: Soho.Locale.translate('Notifications'),
      id: 'Notifications_button',
      automationId: 'lm-appmenu-notifications-button',
      url: this.notificationsUrl
    };

    const createReportButton = {
      icon: '',
      label: Soho.Locale.translate('CreateReport'),
      id: 'CreateReport_link',
      automationId: 'lm-appmenu-create-report-button',
      url: ''
    };

    this.applicationMenuButtons = [];
    this.menuItemSearch = [];

    if (this.evaluateApplicationMenuOption('HideMenuPrintFiles')) {
      if (this.mingleMode) {
        this.printFilesButton = {
          icon: 'print',
          label: Soho.Locale.translate('PrintFiles'),
          id: 'PrintFiles_button',
          automationId: 'lm-appmenu-print-files-button',
          url: this.printFilesUrl
        };
        this.menuItemSearch.push(this.printFilesButton);
      } else {
        this.applicationMenuButtons.push({
          icon: 'print',
          label: Soho.Locale.translate('PrintFiles'),
          id: 'PrintFiles_button',
          automationId: 'lm-appmenu-print-files-button',
          url: this.printFilesUrl
        });
      }
    }

    // Notifications button
    if (this.evaluateApplicationMenuOption('HideMenuNotifications')) {
      this.notificationsButton = notificationsButton;
      this.menuItemSearch.push(this.notificationsButton);
    }

    // Reports button
    if (this.showDataAndReportingOptions('CreateReport')) {
      this.createReportButton = createReportButton;
    }

    if (this.inbasketEnabled && this.evaluateApplicationMenuOption('HideMenuInbasket')) {
      if (this.mingleMode) {
        this.inbasketButton = {
          icon: 'download',
          label: Soho.Locale.translate('Inbasket'),
          id: 'Inbasket_button',
          automationId: 'lm-appmenu-in-basket-button',
          url: this.inBasketUrl
        };
        this.menuItemSearch.push(this.inbasketButton);
      } else {
        this.applicationMenuButtons.push({
          icon: 'download',
          label: Soho.Locale.translate('Inbasket'),
          id: 'Inbasket_button',
          automationId: 'lm-appmenu-in-basket-button',
          url: this.inBasketUrl
        });
      }
    }

    if (this.evaluateApplicationMenuOption('HideMenuJobs')) {
      this.applicationMenuButtons.push({
        icon: 'cascade-objects',
        label: Soho.Locale.translate('Jobs'),
        id: 'Jobs_button',
        automationId: 'lm-appmenu-jobs-button',
        url: this.jobsUrl
      });
    }

    if (this.evaluateApplicationMenuOption('HideMenuReports')) {
      if (this.reportsUrl) {
        let reportsLabel = Soho.Locale.translate('Reports');
        if (this.reportsUrl.includes('/report/catalog')) {
          reportsLabel = Soho.Locale.translate('ReportCatalog');
        }
        this.applicationMenuButtons.push({
          icon: 'report',
          label: reportsLabel,
          id: 'Reports_button',
          automationId: 'lm-appmenu-reports-button',
          url: this.reportsUrl
        });
      }
    }

    if (this.evaluateApplicationMenuOption('HideMenuActions')) {
      this.applicationMenuButtons.push({
        icon: 'checkbox',
        label: Soho.Locale.translate('Actions'),
        id: 'Actions_button',
        automationId: 'lm-appmenu-actions-button',
        url: this.actionsUrl
      });
    }

    if (this.personalizationEnabled) {
      this.applicationMenuButtons.push({
        icon: 'quick-edit',
        label: Soho.Locale.translate('Personalizations'),
        id: 'Personalization_button',
        automationId: 'lm-appmenu-personalization-button',
        url: this.personalizationsUrl
      });
    }

    if (this.enableSavedSearch) {
      this.applicationMenuButtons.push({
        icon: 'print-preview',
        label: Soho.Locale.translate('SavedSearches'),
        id: 'SavedSearches_button',
        automationId: 'lm-appmenu-savedSearches-button',
        url: this.savedSearchesUrl
      });
    }
    this.menuItemSearch = this.menuItemSearch.concat(this.applicationMenuButtons);
    // Add About Link
    if (!this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: 'print-preview',
        label: Soho.Locale.translate('About'),
        id: 'About_button',
        url: this.aboutLink,
        automationId: 'lm-about-button'
      });
    }

    if (this.appHelpLink && !this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Help'),
        id: 'Help_button',
        url: this.appHelpLink,
        automationId: 'lm-help-button'
      });
    }

    if (this.proxyEnabled || this.proxyMode || this.proxyManagementLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Proxy'),
        id: 'Proxy_button',
        url: '',
        automationId: 'lm-proxy-button'
      });
    }

    if (this.enableUserContextMenu) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('ActorContextMenuLabel'),
        id: 'ContextMenu_button',
        url: '',
        automationId: 'lm-contextMenu-button'
      });
    }

    if (this.createReportButton) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('CreateReport'),
        id: 'CreateReport_button',
        url: '',
        automationId: 'lm-createReport-button'
      });
    }

    if (!this.hasChangePasswordLink) {
      this.menuItemSearch.push({
        icon: '',
        label: Soho.Locale.translate('Settings'),
        id: 'Settings_button',
        url: '',
        automationId: 'lm-settings-button'
      });
    }
  }
}
